import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from '../../components/Sidebar/AdminSidebar';

const SIDEBAR_WIDTH = 240;
const SIDEBAR_COLLAPSED_WIDTH = 72;

const AdminLayout = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <div style={{ position: 'fixed', top: 0, left: 0, height: '100vh', zIndex: 1200, width: collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH }}>
        <AdminSidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      <main style={{ marginLeft: collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH, padding: '32px 24px', transition: 'margin-left 0.2s' }}>
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;